import { useEffect, useState } from 'react';

import { Button, Dialog, DialogProps } from 'ui-kit';

import { CloseButton, CompactDialogContainer } from '../deals/dealCards/Diligence/commonStyles';
import { Note } from '../deals/dealCards/Diligence/DealDocumentTypes';

interface NotesDialogProps {
  documentName: string;
  notes: Note[];
  handleAddNote: (text: string) => void;
  dialog: DialogProps;
}

const NotesDialog: React.FC<NotesDialogProps> = ({
  documentName,
  notes,
  handleAddNote,
  dialog,
}) => {
  const [noteText, setNoteText] = useState<string>('');

  useEffect(() => {
    if (dialog.isOpen) {
      setNoteText('');
    }
  }, [dialog.isOpen]);

  return (
    <Dialog dialog={dialog} contentComponent={CompactDialogContainer}>
      <h1 className="relative mx-0 mb-2.5 mt-3px p-0 font-heebo text-xs font-medium leading-4 tracking-normal text-muted-gray">
        Add a Note for "{documentName}"
        <CloseButton onClick={() => dialog.setIsOpen(false)} />
      </h1>
      <div
        data-testid="notes-dialog-list"
        className="flex max-h-444px flex-col gap-5 overflow-y-auto"
      >
        {notes.map((note) => (
          <div key={note.noteID} data-testid="notes-dialog-item">
            <div className="text-gray-500">
              <span>({note.authorRole})</span>
            </div>
            <div className="mb-5px font-pt-sans-narrow text-xxs font-normal leading-3 text-slate-400">
              {new Date(note.createdAt).toDateString()}
            </div>
            <div data-testid="notes-dialog-item-text" className="font-heebo text-sm font-normal">
              {note.note}
            </div>
          </div>
        ))}
      </div>
      <textarea
        aria-label="Add Note"
        data-testid="notes-dialog-textarea"
        value={noteText}
        onChange={(e) => setNoteText(e.target.value)}
        className="my-15px h-118px w-full rounded border border-accent-default bg-background-surface px-2.5 py-5px font-heebo text-sm font-normal text-foreground-default focus:border-accent-default focus:outline-none"
      />
      <div className="flex justify-between gap-2.5">
        <Button
          type="secondary"
          label="cancel"
          size="medium"
          onClick={() => dialog.setIsOpen(false)}
        >
          Cancel
        </Button>
        <Button
          label="add-note"
          size="medium"
          data-testid="notes-dialog-add-button"
          disabled={noteText.length === 0}
          onClick={() => {
            handleAddNote(noteText);
            setNoteText('');
          }}
        >
          Add Note
        </Button>
      </div>
    </Dialog>
  );
};

export default NotesDialog;
